import { useEffect } from 'react';
import isNil from 'lodash/isNil';
import isNumber from 'lodash/isNumber';
type PropsT = {
  mediaElement: HTMLVideoElement | HTMLAudioElement | null;
  volume: number | null;
};
export function useUpdateVolume({
  mediaElement,
  volume
}: PropsT) {
  useEffect(() => {
    if (isNil(volume)) {
      return;
    }
    if (!mediaElement) {
      return;
    }
    if (!isNumber(volume) || volume < 0 || volume > 1) {
      return;
    }
    // eslint-disable-next-line react-hooks/immutability
    mediaElement.volume = (volume as number);
  }, [volume, mediaElement]);
}